// jsPDF için Türkçe (İ, ş, ğ, ç, ö, ü, ı) + Türk Lirası (₺) destekli Unicode font gömme.
// DejaVuSans TTF public/fonts altından yüklenir, base64'e çevrilip jsPDF VFS'ye eklenir.
let _cache = null;

async function fetchB64(url) {
  const buf = await (await fetch(url)).arrayBuffer();
  const bytes = new Uint8Array(buf);
  let bin = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return btoa(bin);
}

// Teklif PDF font seti: Plex (gövde) · Chivo (başlık, normal=700 / bold=900) · JetBrainsMono (kod/no)
const QUOTE_FONTS = [
  ["IBMPlexSans", "normal", "/fonts/IBMPlexSans-Regular.ttf"],
  ["IBMPlexSans", "bold", "/fonts/IBMPlexSans-Bold.ttf"],
  ["Chivo", "normal", "/fonts/Chivo-Bold.ttf"],
  ["Chivo", "bold", "/fonts/Chivo-Black.ttf"],
  ["JetBrainsMono", "normal", "/fonts/JetBrainsMono-Medium.ttf"],
  ["JetBrainsMono", "bold", "/fonts/JetBrainsMono-Bold.ttf"],
];
let _quoteCache = null;

export async function registerQuoteFonts(pdf) {
  if (!_quoteCache) _quoteCache = await Promise.all(QUOTE_FONTS.map(([, , url]) => fetchB64(url)));
  QUOTE_FONTS.forEach(([family, style, url], i) => {
    const file = url.split("/").pop();
    pdf.addFileToVFS(file, _quoteCache[i]);
    pdf.addFont(file, family, style);
  });
  pdf.setFont("IBMPlexSans", "normal");
  return { body: "IBMPlexSans", head: "Chivo", mono: "JetBrainsMono" };
}

let _plexCache = null;

// Yalnız IBM Plex Sans (normal + bold) — ekran şablonuyla (LedgerTemplate) aynı yazı tipi; ₺ ve Türkçe karakterler mevcut.
export async function registerPlexFont(pdf, family = "IBMPlexSans") {
  if (!_plexCache) {
    const [reg, bold] = await Promise.all([fetchB64("/fonts/IBMPlexSans-Regular.ttf"), fetchB64("/fonts/IBMPlexSans-Bold.ttf")]);
    _plexCache = { reg, bold };
  }
  pdf.addFileToVFS("IBMPlexSans-Regular.ttf", _plexCache.reg);
  pdf.addFont("IBMPlexSans-Regular.ttf", family, "normal");
  pdf.addFileToVFS("IBMPlexSans-Bold.ttf", _plexCache.bold);
  pdf.addFont("IBMPlexSans-Bold.ttf", family, "bold");
  pdf.setFont(family, "normal");
  return family;
}

export async function registerTrFont(pdf, family = "DejaVuSans") {
  if (!_cache) {
    const [reg, bold] = await Promise.all([
      fetchB64("/fonts/DejaVuSans.ttf"),
      fetchB64("/fonts/DejaVuSans-Bold.ttf"),
    ]);
    _cache = { reg, bold };
  }
  pdf.addFileToVFS("DejaVuSans.ttf", _cache.reg);
  pdf.addFont("DejaVuSans.ttf", family, "normal");
  pdf.addFileToVFS("DejaVuSans-Bold.ttf", _cache.bold);
  pdf.addFont("DejaVuSans-Bold.ttf", family, "bold");
  pdf.setFont(family, "normal");
  return family;
}
